<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card v-if="hazardous_substance">
      <v-card-title>有害物質</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              名称
            </div>
            <h4>{{ hazardous_substance.name }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              コード
            </div>
            <h4>{{ hazardous_substance.code }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              並び順
            </div>
            <h4>{{ hazardous_substance.position }}</h4>
            <v-divider />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6">
            <div class="overline">
              データ作成日時
            </div>
            <h4>{{ hazardous_substance.created_at | unix_datetime_format }}</h4>
            <v-divider />
          </v-col>
          <v-col cols="12" md="6">
            <div class="overline">
              データ更新日時
            </div>
            <h4>{{ hazardous_substance.updated_at | unix_datetime_format }}</h4>
            <v-divider />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          color="info"
          @click="editButtonClickEvent"
        >
          編集
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import Confirm from '../../../../components/Confirm'
export default {
  name: 'AdminMasterHazardousSubStanceShow',
  components: { Confirm },
  mixins: [],
  data () {
    return {
      breadcrumbs: [
        { text: '有害物質一覧', disabled: false, to: '/admin/masters/hazardous_substances', exact: true },
        { text: '有害物質詳細', disabled: true, to: '' },
      ],
      hazardous_substance: null,
    }
  },
  created() {
    this.hazardous_substance = {
      id: 1,
      code: '01',
      name: '水銀又はその化合物',
      position: 1,
      created_at: 1633314402,
      updated_at: 1633314402,
    }
  },
  methods: {
    editButtonClickEvent () {
      this.$router.push({name: 'AdminMasterHazardousSubStanceEdit', params: {id: this.hazardous_substance.id}})
    },
    deleteButtonClickEvent () {
      let modalOption = { title: '削除', message: '有害物質を削除します。よろしいですか？', options: { titleColor: 'red' } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.$router.push({name: 'AdminMasterHazardousSubStances'})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
